import React from 'react';
import { Stepper } from './Stepper';
import { WizardFooterNav } from './WizardFooterNav';
import { spacing } from '../theme/spacing';
import { colors } from '../theme/colors';
import { typography } from '../theme/typography';

interface WizardLayoutProps {
    currentStep: number;
    steps: string[];
    children: React.ReactNode;
    onBack: () => void;
    onNext: () => void;
    isBackDisabled?: boolean;
    isNextDisabled?: boolean;
    nextLabel?: string;
    isLastStep?: boolean;
    error?: string | null;
    isLoading?: boolean;
}

export const WizardLayout: React.FC<WizardLayoutProps> = ({
    currentStep,
    steps,
    children,
    onBack,
    onNext,
    isBackDisabled,
    isNextDisabled,
    nextLabel,
    isLastStep,
    error,
    isLoading = false,
}) => {
    // Outer container - full viewport with backdrop
    const backdropStyle: React.CSSProperties = {
        minHeight: '100vh',
        backgroundColor: colors.background.offWhite,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: `${spacing[48]} ${spacing[16]}`,
    };

    // Floating card
    const cardStyle: React.CSSProperties = {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        maxWidth: '680px',
        width: '100%',
        padding: spacing[48],
        display: 'flex',
        flexDirection: 'column',
    };

    const contentStyle: React.CSSProperties = {
        flex: 1,
        marginTop: spacing[32],
        marginBottom: spacing[48],
    };

    const errorStyle: React.CSSProperties = {
        backgroundColor: '#FEF2F2',
        border: '1px solid #FECACA',
        borderRadius: '8px',
        padding: spacing[16],
        marginBottom: spacing[16],
        fontFamily: typography.fontFamily,
        fontSize: typography.sizes.body.fontSize,
        color: '#991B1B',
        lineHeight: 1.5,
    };

    return (
        <div style={backdropStyle}>
            <div style={cardStyle}>
                <Stepper currentStep={currentStep} steps={steps} />

                <main style={contentStyle}>
                    {children}
                </main>

                {error && (
                    <div style={errorStyle}>
                        {error}
                    </div>
                )}

                <WizardFooterNav
                    onBack={onBack}
                    onNext={onNext}
                    isBackDisabled={isBackDisabled}
                    isNextDisabled={isNextDisabled}
                    nextLabel={nextLabel}
                    isLastStep={isLastStep}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};
